import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { APP_ROUTES } from '@core/constants/routes.constants';
import { UIService } from '@core/services/ui.service';
import { TranslateService } from '@ngx-translate/core';
import { map, of, switchMap } from 'rxjs';
import { AuthService } from './auth.service';

export function authGuard() {
  const router = inject(Router);
  const authService = inject(AuthService);
  const uiService = inject(UIService);
  const translateService = inject(TranslateService);

  return authService.authenticate().pipe(
    switchMap((isAuthenticated: boolean) => {
      if (!isAuthenticated) {
        return translateService.get('errors.loginAgain').pipe(
          map((translatedMessage: string) => {
            uiService.showToast({
              severity: 'error',
              summary: translatedMessage,
              life: 3000,
              closable: false,
            });

            router.navigate([APP_ROUTES.AUTH, APP_ROUTES.LOGIN], {
              queryParams: {
                redirectUrl: router.currentNavigation()?.initialUrl.toString(),
              },
            });

            return false;
          })
        );
      }
      return of(true);
    })
  );
}
